export default __webpack_public_path__ + "static/media/Battleburn Stout.5588395c.jpg";